import { render, staticRenderFns } from "./AlertSummary.vue?vue&type=template&id=05fb1b19&scoped=true"
import script from "./AlertSummary.vue?vue&type=script&lang=js"
export * from "./AlertSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fb1b19",
  null
  
)

export default component.exports